import * as ACTION_TYPES from './constants';

import { Setting } from '../../../Api';

import { Toast } from '../../Common';

const Api = Setting.Customer;

const reducer = 'SettingCustomerReducer';

export default class SettingCustomerActions {
    static loading_index = toggle => ({
        type: ACTION_TYPES.SETTING_CUSTOMER_LOADING_INDEX,
        toggle,
    });

    static loading_show = toggle => ({
        type: ACTION_TYPES.SETTING_CUSTOMER_LOADING_SHOW,
        toggle,
    });

    static loading_resource = toggle => ({
        type: ACTION_TYPES.SETTING_CUSTOMER_LOADING_RESOURCE,
        toggle,
    });

    static search =
        (search = {}) =>
        async (dispatch, getState) => {
            dispatch({ type: ACTION_TYPES.SETTING_CUSTOMER_SEARCH, search });
        };

    static requests = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_index(true));
            const query = getState()[reducer].get('search');
            const res = await Api.index(query);
            if (res instanceof Error) throw res;
            dispatch(this.index(res));
        } catch (error) {
            dispatch(this.loading_index(false));
            console.error(error);
        } finally {
        }
    };

    static index = (customers = []) => ({
        type: ACTION_TYPES.SETTING_CUSTOMER_INDEX,
        customers,
    });

    static request = params => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const res = await Api.show(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static create = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const body = getState()[reducer].get('customer');
            const res = await Api.create(body);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
            Toast.success('记录已保存');
            dispatch(this.requests());
            dispatch(this.options());
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static destroy = () => async (dispatch, getState) => {
        try {
            const params = getState()[reducer].getIn(['customer', 'id']);
            dispatch(this.loading_show());
            const res = await Api.destroy(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
            Toast.success('记录已删除');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_show());
            console.error(error);
        } finally {
        }
    };

    static show = (customer = {}) => ({
        type: ACTION_TYPES.SETTING_CUSTOMER_SHOW,
        customer,
    });

    static reset = () => ({
        type: ACTION_TYPES.SETTING_CUSTOMER_RESET,
    });

    static column = (columns = []) => ({
        type: ACTION_TYPES.SETTING_CUSTOMER_COLUMN,
        columns,
    });

    static options = () => async (dispatch, getState) => {
        try {
            const res = await Api.options();
            if (res instanceof Error) throw res;
            dispatch({
                type: ACTION_TYPES.SETTING_CUSTOMER_OPTION,
                options: res,
            });
        } catch (error) {
            console.error(error);
        } finally {
        }
    };

    static course = () => async (dispatch, getState) => {
        try {
            const res = await Api.course();
            if (res instanceof Error) throw res;
            dispatch({
                type: ACTION_TYPES.SETTING_CUSTOMER_COURSE,
                courses: res,
            });
        } catch (error) {
            console.error(error);
        } finally {
        }
    };

    static resource_request = params => async (dispatch, getState) => {
        try {
            dispatch(this.loading_resource());
            const res = await Api.resource_request(params);
            if (res instanceof Error) throw res;
            dispatch(this.resource(res));
        } catch (error) {
            dispatch(this.loading_resource(false));
            console.error(error);
        } finally {
        }
    };

    static resource_create = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_resource());
            const customers_id = getState()[reducer].getIn(['resource', 'customers_id']);
            const body = getState()[reducer].get('resource');
            const res = await Api.resource_create(body);
            if (res instanceof Error) throw res;
            dispatch(this.resource(res));
            Toast.success('记录已保存');
            dispatch(this.request(customers_id));
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_resource(false));
            console.error(error);
        } finally {
        }
    };

    static resource_upload = body => async (dispatch, getState) => {
        try {
            dispatch(this.loading_resource());
            const res = await Api.resource_upload(body);
            if (res instanceof Error) throw res;
            dispatch(this.resource(res));
            Toast.success('记录已保存');
            dispatch(this.request(res.customers_id));
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_resource(false));
            console.error(error);
        }
    };

    static resource_destroy = () => async (dispatch, getState) => {
        try {
            const customers_id = getState()[reducer].getIn(['resource', 'customers_id']);
            const params = getState()[reducer].getIn(['resource', 'id']);
            dispatch(this.loading_resource());
            const res = await Api.resource_destroy(params);
            if (res instanceof Error) throw res;
            dispatch(this.resource(res));
            Toast.success('记录已删除');
            dispatch(this.request(customers_id));
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_resource(false));
            console.error(error);
        } finally {
        }
    };

    static resource_remove = body => async (dispatch, getState) => {
        try {
            dispatch(this.loading_resource());
            const customers_id = getState()[reducer].getIn(['resource', 'customers_id']);
            const resource = getState()[reducer].get('resource');
            const res = await Api.resource_remove({ ...body, resource });
            if (res instanceof Error) throw res;
            dispatch(this.resource(res));
            Toast.success('记录已保存');
            dispatch(this.request(customers_id));
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_resource(false));
            console.error(error);
        }
    };

    static resource = (resource = {}) => ({
        type: ACTION_TYPES.SETTING_CUSTOMER_RESOURCE,
        resource,
    });
}
